import React from 'react';
import { useSelector } from 'react-redux';
import { selectShowEntityInspector } from 'src/store/selectors/entityInfoSelectors';
import { EntityEndpoint } from 'src/interfaces/modular/entityInfoTypes';
import InspectorContent from 'src/components/EntityInspector/Inspectable/InspectorContent';
import { selectIsSuper } from 'src/store/selectors/userInfo';
function Inspectable({ children, entity, endpoint = EntityEndpoint.Default }) {
    const isSuper = useSelector(selectIsSuper);
    const showInspector = useSelector(selectShowEntityInspector);
    if (!isSuper || !entity)
        return children;
    return (React.createElement(InspectorContent, { entity: entity, showInspector: showInspector, endpoint: endpoint }, children));
}
export default Inspectable;
